export const OFFICE_TYPE = {
  HEAD: "head",
  BRANCH: "branch",
  PRESENCE: "presence",
  GLOBAL: "global",
};

/** NCR cluster — dotted line connects these in order (side by side on map). */
export const NCR_CHAIN = ["delhi", "noida", "gurgaon", "faridabad", "chandigarh"];

/**
 * Coordinates match the India SVG viewBox (600×680) — all pins sit on mainland India.
 */
export const PRESENCE_LOCATIONS = [
  { key: "delhi", city: "Delhi", type: OFFICE_TYPE.HEAD, x: 184, y: 195, label: "Head Office" },
  { key: "noida", city: "Noida", type: OFFICE_TYPE.PRESENCE, x: 196, y: 192, label: "Presence (India)" },
  { key: "gurgaon", city: "Gurgaon", type: OFFICE_TYPE.PRESENCE, x: 176, y: 198, label: "Presence (India)" },
  { key: "faridabad", city: "Faridabad", type: OFFICE_TYPE.PRESENCE, x: 190, y: 206, label: "Presence (India)" },
  { key: "chandigarh", city: "Chandigarh", type: OFFICE_TYPE.PRESENCE, x: 176, y: 148, label: "Presence (India)" },
  { key: "dehradun", city: "Dehradun", type: OFFICE_TYPE.PRESENCE, x: 192, y: 172, label: "Presence (India)" },
  { key: "jaipur", city: "Jaipur", type: OFFICE_TYPE.PRESENCE, x: 156, y: 232, label: "Presence (India)" },
  { key: "jodhpur", city: "Jodhpur", type: OFFICE_TYPE.PRESENCE, x: 132, y: 255, label: "Presence (India)" },
  { key: "udaipur", city: "Udaipur", type: OFFICE_TYPE.PRESENCE, x: 142, y: 278, label: "Presence (India)" },
  { key: "kota", city: "Kota", type: OFFICE_TYPE.PRESENCE, x: 158, y: 295, label: "Presence (India)" },
  { key: "ahmedabad", city: "Ahmedabad", type: OFFICE_TYPE.PRESENCE, x: 96, y: 320, label: "Presence (India)" },
  { key: "gandhinagar", city: "Gandhinagar", type: OFFICE_TYPE.PRESENCE, x: 100, y: 310, label: "Presence (India)" },
  { key: "vadodara", city: "Vadodara", type: OFFICE_TYPE.PRESENCE, x: 115, y: 332, label: "Presence (India)" },
  { key: "bhopal", city: "Bhopal", type: OFFICE_TYPE.PRESENCE, x: 200, y: 348, label: "Presence (India)" },
  { key: "lucknow", city: "Lucknow", type: OFFICE_TYPE.PRESENCE, x: 259, y: 234, label: "Presence (India)" },
  { key: "patna", city: "Patna", type: OFFICE_TYPE.PRESENCE, x: 338, y: 278, label: "Presence (India)" },
  { key: "kolkata", city: "Kolkata", type: OFFICE_TYPE.PRESENCE, x: 407, y: 327, label: "Presence (India)" },
  { key: "odisha", city: "Odisha", type: OFFICE_TYPE.PRESENCE, x: 385, y: 400, label: "Presence (India)" },
  { key: "hyderabad", city: "Hyderabad", type: OFFICE_TYPE.PRESENCE, x: 210, y: 441, label: "Presence (India)" },
  { key: "mumbai", city: "Mumbai", type: OFFICE_TYPE.BRANCH, x: 102, y: 404, label: "Branch Office" },
  { key: "pune", city: "Pune", type: OFFICE_TYPE.PRESENCE, x: 120, y: 416, label: "Presence (India)" },
  { key: "goa", city: "Goa", type: OFFICE_TYPE.PRESENCE, x: 118, y: 438, label: "Presence (India)" },
  { key: "bengaluru", city: "Bangalore", type: OFFICE_TYPE.BRANCH, x: 192, y: 538, label: "Branch Office" },
  { key: "chennai", city: "Chennai", type: OFFICE_TYPE.PRESENCE, x: 245, y: 536, label: "Presence (India)" },
  { key: "kochi", city: "Kochi", type: OFFICE_TYPE.PRESENCE, x: 168, y: 585, label: "Presence (India)" },
];

export const PRESENCE_BY_KEY = Object.fromEntries(
  PRESENCE_LOCATIONS.map((loc) => [loc.key, loc]),
);
